import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export interface Freebie { kind: string; title: string; season: string; preview: string }
const cache: Record<string, Promise<Freebie>> = {};

// Follows the season (and ?season= previews), so the offer always matches the time of year.
export function useFreebie() {
  const [sp] = useSearchParams();
  const key = sp.get("season") || "";
  const [f, setF] = useState<Freebie | null>(null);
  useEffect(() => {
    let live = true;
    cache[key] ||= api.get("/public/freebie-info", { params: key ? { season: key } : {} }).then((r) => r.data);
    cache[key].then((d) => { if (live) setF(d); }).catch(() => { delete cache[key]; });
    return () => { live = false; };
  }, [key]);
  return f;
}

export const freebieTitle = (f: Freebie | null) => f?.title || "a free printable";
